export const addToHistory = (exhibitId) => {
  const history = getHistory();
  if (!history.includes(exhibitId)) {
    const newHistory = [exhibitId, ...history];
    localStorage.setItem("exhibitHistory", JSON.stringify(newHistory));
  }
};

export const getHistory = () => {
  try {
    const history = localStorage.getItem("exhibitHistory");
    return history ? JSON.parse(history) : [];
  } catch (e) {
    return [];
  }
};

export const clearHistory = () => {
  localStorage.removeItem("exhibitHistory");
};
